module.exports=function(scope){ return `<!-- Liveness passed -->
{
    "data": {
        "glasses": false,
        "sessionTokenStatus": 2,
        "faceMapType": 0,
        "livenessStatus": 0,
        "auditTrailVerificationCheck": 0,
        "isLowQuality": false,
        "auditTrailMatchCheck": 0,
        "isReplayFaceMap": false
    },
    "meta": {
        "code": 200,
        "message": "The ZoOm 3D FaceMap evaluated and Liveness was proven.",
        "ok": true,
        "m": {
            "prepareAndUpdateTimeInMS": ...,
            "totalDurationInMS": ...
        }
    }
}

<!-- Liveness undetermined -->
{
    "data": {
        "glasses": false,
        "sessionTokenStatus": 2,
        "faceMapType": 0,
        "livenessStatus": 1,
        "auditTrailVerificationCheck": 1,
        "isLowQuality": false,
        "auditTrailMatchCheck": 1,
        "isReplayFaceMap": false
    },
    "meta": {
        "code": 200,
        "message": "The ZoOm 3D FaceMap evaluated and Liveness was not proven.  The developer should prompt the user with retry guidance as demonstrated in the Device SDK Sample Apps.",
        "ok": true,
        "m": {
            "prepareAndUpdateTimeInMS": ...,
            "totalDurationInMS": ...
        }
    }
}`};


// WEBPACK FOOTER //
// ./src/resources/code/restsdk-v2/response/success/liveness.json.tpl